import { render } from "./En022.vue?vue&type=template&id=5ccd6a28"
import script from "./En022.vue?vue&type=script&lang=js"
export * from "./En022.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__